export const LogoMark = ({ className = "h-9 w-auto", dark = false }) => (
  <img
    src={dark ? "/logo-mark-light.png" : "/logo-mark-dark.png"}
    alt="ART Ceiling ženklas"
    className={className}
  />
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark dark={dark} />
    <span className="flex flex-col justify-center">
      <span
        className={`block font-heading text-lg font-extrabold leading-[1.15] tracking-tight ${
          dark ? "text-white" : "text-navy-900"
        }`}
      >
        ART <span className="font-medium">Ceiling</span>
      </span>
      <span
        className={`block text-[9px] font-bold leading-[1.3] tracking-[0.22em] uppercase ${
          dark ? "text-sky-300" : "text-sky-600"
        }`}
      >
        Įtempiamos lubos
      </span>
    </span>
  </span>
);
